import success from './result/success'
import fail from './result/fail'

export default {
  'result.response.finishTime': 'Finish Time: ',
  'result.response.code': 'Code: ',
  'result.response.size': 'Size: ',
  'result.response.time': 'Time: ',

  ...success,
  ...fail
}
